<template>
  <div class="bg-whiteOverride border-solid border-1 border-border rounded-lg shadow-cardContainer">
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

/**
 * This component is **only** intended to be used as a building
 * block in other library/ui components. We have intentionally
 * avoided adding spacing so that **when wrapped** in another
 * component, the spacing can be added to the slot content.
 */
export default defineComponent({
  name: 'CardContainer',
});
</script>
